module.exports = __webpack_public_path__ + "img/mxf.fbf1e6c6.svg";